import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = [];

  initialize() {
    this.redirectByAct();
  }

  redirectByAct() {
    const containerId = new URLSearchParams(location.search).get('view');

    if (containerId) {
      const $target = document.querySelector(`#card_${containerId} .btn[data-act="view"]`);

      setTimeout(() => {
        $target && $target.click();
      }, 100);
    }
  }
}
